module.exports = __webpack_public_path__ + "static/media/va.f0f347b8.webp";